<template lang="pug">
    div
        Table(border ref="selection" :columns="columns" :data="data" @on-selection-change="handleSelect")
</template>
<script>
export default {
    name: "OwaspDetectRulesTable",
    props: {
        value: {
            default: () => [],
        },
    },
    data() {
        return {
            columns: [
                {
                    type: "selection",
                    width: 60,
                    align: "center",
                },
                {
                    title: "ModSecurity Core Rule Set",
                    key: "crs",
                },
            ],
            data: [],
        };
    },
    methods: {
        handleDefaultSelect() {
            let data = [
                { crs: "REQUEST-930-APPLICATION-ATTACK-LFI" },
                { crs: "REQUEST-931-APPLICATION-ATTACK-RFI" },
                { crs: "REQUEST-932-APPLICATION-ATTACK-RCE" },
                { crs: "REQUEST-933-APPLICATION-ATTACK-PHP" },
                { crs: "REQUEST-934-APPLICATION-ATTACK-GENERIC" },
                { crs: "REQUEST-941-APPLICATION-ATTACK-XSS" },
                { crs: "REQUEST-942-APPLICATION-ATTACK-SQLI" },
                { crs: "REQUEST-943-APPLICATION-ATTACK-SESSION-FIXATION" },
                { crs: "REQUEST-944-APPLICATION-ATTACK-JAVA" },
            ];
            this.data = data.map((item) => {
                // _disabled
                item._disabled = true;
                // _check
                item._checked = this.value.includes(item.crs) ? true : false;
                return item;
            });
            return this.data;
        },
        handleSelect(selection, row) {
            this.$emit(
                "input",
                selection.map((item) => item.crs)
            );
        },
    },
    created() {
        this.handleDefaultSelect();
    },
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/OwaspDetectRulesTable.vue